var utils = require( './utils' );

var account_page_menu = ( function( $ ) {

	var $menu;

	var _init = function() {
		$menu = $( '#account-sidebar' );

		$menu.find( 'a.toggle-link' ).on( 'click', _toggle_menu );
	};

	var _toggle_menu = function( e ) {
		e.preventDefault();

		$( this ).toggleClass( 'open' );
		$menu.find( '.toggle-panel' ).slideToggle();
	};

	if ( $( '#account-sidebar' ).length > 0 && utils.viewport_size().width <= 1200 ) {
		$( document ).ready( _init );
	}

} ) ( jQuery );

module.exports = account_page_menu;